import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getHotelCityContentList } from '../../services/hotel/hotelServices';

export const fetchHotelCityContent = createAsyncThunk(
    'seo/fetchHotelCityContent',
    async ({ city }, { rejectWithValue }) => {
        try {
            const data = await getHotelCityContentList(city);
            return data;
        } catch (error) {
            return rejectWithValue(seoError.response?.data || error);
        }
    }
);

const cityHotelSlice = createSlice({
    name: 'seoHotelCity',
    initialState: {
        content: null,
        loading: false,
        seoError: null,
    },
    reducers: {
        clearCityHotelContent: (state) => {
            state.content = null;
            state.seoError = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchHotelCityContent.pending, (state) => {
                state.loading = true;
                state.seoError = null;
                state.data = null; 
            })
            .addCase(fetchHotelCityContent.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload && Object.keys(action.payload).length > 0
                    ? action.payload
                    : null;
            })
            .addCase(fetchHotelCityContent.rejected, (state, action) => {
                state.loading = false;
                state.seoError = action.payload;
                state.data = null;
            });

    },
});

export const { clearCityHotelContent } = cityHotelSlice.actions;
export default cityHotelSlice.reducer;
